function get(obj, key, def){return obj[key] || def};

export { get }


// WEBPACK FOOTER //
// ./src/utils.js